<div class="invitation-accepted text-center">
    <div class="invitation-accepted__illu align-center">
        <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                     [isSuccess]="true"
                                                     class="margin-bottom-50">
        </app-header-invitation-b2b-partnership-logos>
    </div>
    <div class="invitation-accepted__content">
        <div class="invitation-accepted__title">
            {{ isPartner
                ? ('Operation finalisee, vous pouvez desormais collaborer plus facilement avec votre client !' | transloco)
            : ('Operation finalisee, vous pouvez desormais collaborer plus facilement avec votre partenaire !' | transloco) }}
        </div>
        <p class="invitation-accepted__subtitle margin-bottom-50" *ngIf="!isPartner && (invitation.type === 'full')">
            {{ isPartner
                ? ('Pour gerer votre nouveau client, rendez-vous dans votre espace revendeur du Manager (clients sous gestion)' | transloco)
            : ('Ce partenaire ne possede pas encore d\'acces a vos produits. Vous pouvez gerer votre partenaire afin de lui ajouter des produits et lui attribuer les droits d\'acces souhaites.' | transloco) }}
        </p>
        <div class="invitation-accepted__buttons">
            <div class="dashboard-link">
                <a [href]="managerLink"
                   mat-flat-button
                   color="primary">
                    <span>{{ isPartner ? ('Gerer mon client' | transloco) : ('Gerer mon partenaire' | transloco) }}</span>
                </a>
            </div>
        </div>
    </div>
</div>
